import styled, { css } from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 24px 24px 0px 0px;
  display: grid;
  grid-gap: 32px;
  width: 100vw;

  ${({ haveHead }) =>
    haveHead &&
    css`
      grid-template-rows: 48px auto;
    `};

  ${({ bottom }) =>
    bottom &&
    css`
      align-self: flex-end;
    `};

  ${media.greaterThan("medium")`
    border-radius: 24px;
    align-self: flex-start;
    width: 100%;
    justify-self: center;

    ${({ noBackground }) =>
      noBackground &&
      css`
        background-color: transparent;
      `}

    ${({ noPadding }) =>
      noPadding &&
      css`
        padding: 0;
        border-radius: 0;
      `}
  `}
`;

export const Content = styled.div`
  display: grid;
  grid-gap: 32px;
  width: 100%;
  padding: 0 16px 16px 16px;

  ${({ haveHead }) =>
    !haveHead &&
    css`
      padding: 16px;
    `};

  ${media.greaterThan("medium")`
    padding: 32px;    
    ${({ noPadding }) =>
      noPadding &&
      css`
        padding: 0;
      `}
  `}
`;

export const Head = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 24px auto;
  grid-gap: 8px;
  height: min-content;
  align-items: center;
  padding: 16px 16px 0px 16px;

  p {
    height: min-content;
  }

  ${media.greaterThan("medium")`  
    padding: 24px 32px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
  `}
`;
